function ProductVariantColour({ value, option, onSelect, isSelected, isDisabled }) {
  const getSwatchClass = (name) => `colour-swatch-${name.toLowerCase()}`

  const className = [
    'relative mt-2 size-12 rounded-full border-2 border-white outline outline-1 outline-transparent',
    isSelected && 'outline-default',
    isDisabled && 'bg-cross',
    getSwatchClass(value)
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type="button"
      name={value}
      className={className}
      aria-label={getSwatchClass(value)}
      onClick={() => onSelect(value, option)}
    />
  )
}

export default ProductVariantColour
